import { defineStore } from "pinia";
import { useLeftMenuSetup } from "./leftMenu";

export const useNavigationStore = defineStore("navigation", () => {
  const leftMenu = useLeftMenuSetup();

  return {
    ...leftMenu
  };
});
